<template>
    <v-col cols="12">
        <v-row>
            <v-col cols="12" lg="6" order="first" order-lg="last" class="pa-0">
                <v-row align="center" justify="end" class="pa-0">
                    <v-col cols="5" md="3" lg="5" xl="4" class="pa-0">
                        <v-text-field
                            v-model="search"
                            :label="$t('store.search')"
                            append-icon="fas fa-search"
                            outlined
                            rounded
                            dense
                            class="pt-7 pt-lg-1 px-2 px-lg-7"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="5" md="4" xl="3" class="pa-0 pb-lg-5">
                        <v-chip
                            outlined
                            rounded
                            color="primary"
                            class="py-5"
                        >
                            <v-img src="/img/user/beecoin-3.svg" height="30" width="30">
                            </v-img>
                            <span class="black--text text-body-2">
                                {{ $t('store.you_have') }}
                                <strong>
                                    {{ coins }} Beecoins
                                </strong>
                            </span>
                            
                        </v-chip>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" lg="6" order="last" order-lg="first" class="pa-0">
                <v-tabs
                    v-model="tab"
                    class="mb-10"
                    height="40"
                    slider-size="6"
                    slider-color="#FF6F3A"
                    @change="$emit('new-tab', tab)"
                >   
                    <v-tab
                        v-for="item in items"
                        :key="item"
                        class="no-uppercase text-subtitle-1 tab-items"
                        active-class="font-weight-black black--text"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>

import { mapState } from 'vuex'

export default {
    data() {
        return {
            tab: 0,
            search: ''
        }
    },
    computed: {
        ...mapState({
            coins: (state) => state.userData.coins
        }),
        items () {
            return [
                this.$t('store.books'),
                this.$t('store.avatars'),
                this.$t('store.skins'),
                this.$t('store.favorites')
            ]
        }
    },
    watch: {
        search() {
            this.$emit('search', this.search)
        }
    }
}
</script>

<style scoped>
.no-uppercase {
     text-transform: none;
}
.v-tabs-bar {
    height: 80px  !important;
}
.v-tabs-bar__content {
    height: 80px  !important;
}
.v-tabs-slider-wrapper {
    height: 5px;
}
.tab-items {
    border-bottom: 6px solid #FFE1D7;
    margin-left: 10px;
    margin-right: 10px;
}
.v-chip:before {
    background-color: white;
}
</style>